import {IActionConfiguration} from './action.configuration.interface';

export class MailActionModel implements IActionConfiguration {
  name: string;
  configuration: any;
  constructor() {
    this.configuration = {};
  }
}



// WEBPACK FOOTER //
// ./src/app/rules/model/mail.action.model.ts